import React from 'react';
import { Dialog, Box, Typography, Avatar } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import Button from '../UIKit/Button';
import { useTranslation } from 'react-i18next';

const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  contentText,
  confirmButtonText,
  badge,
  series,
  handleDeleteBadge,
  handleDeleteSeries,
}) => {
  const { t } = useTranslation(['badges', 'common']);

  // Определяем тип диалога (удаление значка или серии)
  const isSeriesDelete = !!series;
  const displayTitle =
    title ||
    (isSeriesDelete
      ? t('badges:badgeManagement.confirmDelete.seriesTitle')
      : t('badges:badgeManagement.confirmDelete.title'));

  const displayText =
    contentText ||
    (isSeriesDelete
      ? t('badges:badgeManagement.confirmDelete.seriesMessage', { name: series?.name })
      : t('badges:badgeManagement.confirmDelete.message', { name: badge?.name }));

  // Определяем функцию для подтверждения удаления
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else if (isSeriesDelete && handleDeleteSeries) {
      handleDeleteSeries(series._id);
    } else if (badge && handleDeleteBadge) {
      handleDeleteBadge();
    }

    if (onClose) onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '16px',
          p: 2,
        },
      }}
    >
      <Box sx={{ textAlign: 'center', p: 3 }}>
        <Avatar
          sx={{
            bgcolor: 'error.main',
            width: 64,
            height: 64,
            margin: '0 auto',
            mb: 2,
          }}
        >
          <DeleteIcon sx={{ color: 'white', fontSize: 32 }} />
        </Avatar>
        <Typography
          variant="h5"
          sx={{ mb: 1, fontSize: '1.25rem', fontWeight: 600 }}
        >
          {displayTitle}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {displayText}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button onClick={onClose} variant="outlined" sx={{ minWidth: 100 }}>
            {t('common:actions.cancel')}
          </Button>
          <Button onClick={handleConfirm} color="error" variant="contained">
            {confirmButtonText || t('common:actions.delete')}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
